import axios from "axios";
import { toast } from "sonner";
import { dayStatus } from "@/lib/dayStatus";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Exempt from the "must start your day first" gate below: auth itself (so login/logout
// always work), and the attendance start/stop/today calls (otherwise starting your day
// would itself be blocked for not having started your day).
const DAY_GATE_EXEMPT = [/^\/auth\//, /^\/hrms\/attendance\//];

api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (method === "get" || !dayStatus.checked || dayStatus.started) return config;
  const path = (config.url || "").replace(API, "");
  if (DAY_GATE_EXEMPT.some((re) => re.test(path))) return config;
  toast.error("Start your day to make changes — editing is read-only until then.");
  const err = new Error("Day not started");
  err.isDayNotStarted = true;
  return Promise.reject(err);
});

export const get = (url, config) => api.get(url, config).then((r) => r.data);
export const post = (url, body) => api.post(url, body).then((r) => r.data);
export const patch = (url, body) => api.patch(url, body).then((r) => r.data);
export const put = (url, body) => api.put(url, body).then((r) => r.data);
export const del = (url) => api.delete(url).then((r) => r.data);

// For file uploads — pass a FormData instance; axios sets the multipart boundary itself.
// onProgress(percent: 0-100) is called repeatedly as the upload streams, for a progress bar.
export const uploadFile = (url, formData, onProgress) => api.post(url, formData, {
  onUploadProgress: onProgress ? (e) => onProgress(e.total ? Math.round((e.loaded / e.total) * 100) : 0) : undefined,
}).then((r) => r.data);

// Opens a DMS file's decrypt-and-stream endpoint in a new tab. The session cookie is
// sameSite=lax, which is still sent on this kind of top-level GET navigation, so no
// separate token/fetch dance is needed — the backend checks visibility and streams the
// actual (decrypted, decompressed) file straight back.
export const openDmsFile = (fileId) => {
  window.open(`${API}/dms/files/${fileId}/download`, "_blank", "noopener,noreferrer");
};
